import CloseButton from './buttons/CloseButton'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import I18n from 'i18n'

export const ERROR = 'ERROR'
export const INFO = 'INFO'
export const SUCCESS = 'SUCCESS'
export const WARNING = 'WARNING'

export default class AlertListItem extends PureComponent {
  static propTypes = {
    alert: PropTypes.shape({
      persistent: PropTypes.bool,
      htmlSafe: PropTypes.bool,
      message: PropTypes.string.isRequired,
      type: PropTypes.oneOf([ERROR, INFO, SUCCESS, WARNING]).isRequired
    }),
    onCloseClick: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.closeAlert = this.closeAlert.bind(this)
  }

  closeAlert() {
    const { alert, onCloseClick } = this.props
    onCloseClick(alert)
  }

  render() {
    const { alert } = this.props
    const { persistent, htmlSafe, message, type } = alert

    const classes = classNames('alert', {
      'alert-danger': type === ERROR,
      'alert-info': type === INFO,
      'alert-success': type === SUCCESS,
      'alert-warning': type === WARNING
    })

    return (
      <div className={classes}>
        {!persistent && <CloseButton onClick={this.closeAlert} />}
        {htmlSafe && <span dangerouslySetInnerHTML={{ __html: message }} />}
        {!htmlSafe && <span>{I18n.t(message)}</span>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/AlertListItem.js